export default "__VITE_ASSET__Bo9bnHwV__"